var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable, observable } from 'mobx';
import { MandateType } from '../config/mandate';
import API from '../util/ApiUtil';
import { isBefore, parse, startOfDay } from 'date-fns';
export default class InvoiceStore {
    constructor(rootStore) {
        Object.defineProperty(this, "invoicesWrapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { status: 'UNINITIALIZED' }
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handleSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                const invoices = response.data.invoices;
                this.invoicesWrapper.invoices = invoices.map(this.addSettlementsAndDueDatePassed);
                this.invoicesWrapper.totalAmountToPay = response.data.totalAmountToPay;
                this.invoicesWrapper.status = 'FETCHED';
            }
        });
        Object.defineProperty(this, "handleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (error) => {
                console.error(error);
                this.invoicesWrapper.status = 'ERROR';
            }
        });
        makeObservable(this);
        this.mandateStore = rootStore.mandateStore;
    }
    async fetchInvoices() {
        await this.mandateStore.loadMandateInfo([MandateType.LEGAL, MandateType.BILLING], false);
        if (this.hasMandates) {
            await this.getInvoices();
        }
    }
    getInvoices() {
        this.invoicesWrapper.status = 'FETCHING';
        return API.get('/billing/invoices').then(this.handleSuccess).catch(this.handleError);
    }
    get hasUnsettledInvoices() {
        return (this.invoicesWrapper &&
            this.invoicesWrapper.invoices &&
            this.invoicesWrapper.invoices.some((value) => value.isTotallyUnsettled || value.isPartiallyUnsettled));
    }
    get hasMandates() {
        return this.mandateStore.hasMandate([MandateType.LEGAL, MandateType.BILLING], false);
    }
    isFetching() {
        return ['FETCHING'].includes(this.invoicesWrapper.status);
    }
    hasError() {
        return this.invoicesWrapper.status === 'ERROR';
    }
    addSettlementsAndDueDatePassed(invoice) {
        const { amount, unsettledAmount } = invoice;
        const isDueDatePassed = isInvoiceDueDatePassed(invoice);
        return {
            ...invoice,
            isDueDatePassed,
            isTotallyUnsettled: unsettledAmount > 0 && unsettledAmount === amount,
            isPartiallyUnsettled: unsettledAmount > 0 && unsettledAmount < amount
        };
    }
}
__decorate([
    observable
], InvoiceStore.prototype, "invoicesWrapper", void 0);
__decorate([
    action.bound
], InvoiceStore.prototype, "fetchInvoices", null);
__decorate([
    action.bound
], InvoiceStore.prototype, "getInvoices", null);
__decorate([
    action.bound
], InvoiceStore.prototype, "handleSuccess", void 0);
__decorate([
    action.bound
], InvoiceStore.prototype, "handleError", void 0);
__decorate([
    computed
], InvoiceStore.prototype, "hasUnsettledInvoices", null);
__decorate([
    computed
], InvoiceStore.prototype, "hasMandates", null);
const isInvoiceDueDatePassed = (invoice) => {
    let invoiceDueDate = parse(invoice.dueDate, 'dd.MM.yyyy', new Date());
    invoiceDueDate = new Date(invoiceDueDate.valueOf() - invoiceDueDate.getTimezoneOffset() * 60 * 1000);
    return isBefore(invoiceDueDate, startOfDay(new Date()));
};
